import { Box, Grid, useMediaQuery } from "@mui/material";
import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { useSettings } from "src/@core/hooks/useSettings";
import LoginImage from "../assets/images/BikeDealer.svg";
import EmailIcon from "@mui/icons-material/Email";

const LeftWrapper = styled(Box)(({ theme }) => ({
  height: "100vh",
  display: "flex",
  flex: 1,
  padding: "20px",
}));

const LeftContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundImage: `url(${LoginImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  borderRadius: "20px",
  overflow: "hidden",
  position: "relative",
}));

const RightWrapper = styled(Box)(({ theme }) => ({
  margin: "auto",
  [theme.breakpoints.up("md")]: {
    maxWidth: 774,
  },
}));

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  const { settings } = useSettings();
  const { skin } = settings;
  const hidden = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid container className="content-right" style={{ height: "100vh" }}>
      {/*Left Side Image */}
      {/* {!hidden && (
        <Grid item xs={12} md={6}>
          <LeftWrapper>
            <LeftContainer>
              <Box
                sx={{
                  position: "absolute",
                  fontWeight: 600,
                  bottom: 14,
                  left: 10,
                  gap: 2,
                  display: "flex",
                  alignItems: "center",
                  color: "#fff",
                  fontSize: "14px",
                }}
              >
                <EmailIcon />
                abc@gmail.com
              </Box>
            </LeftContainer>
          </LeftWrapper>
        </Grid>
      )} */}

      {/* Right Side Form (Now on the Right) */}
      <Grid item xs={12} md={12}>
        <Box className="content-center" sx={{ height: "100%" }}>
          <RightWrapper
            sx={
              skin === "bordered" && !hidden
                ? { borderLeft: `1px solid ${theme.palette.divider}` }
                : {}
            }
          >
            {hidden && (
              <Box display="flex" justifyContent="center" alignItems="center">
                {/* Optional mobile logo or heading */}
              </Box>
            )}
            {children}
          </RightWrapper>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
